/*
 * UserList Messages
 *
 * This contains all the text for the UserList component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  name: {
    id: 'app.components.DepotForm.name',
    defaultMessage: 'Name',
  },
  address: {
    id: 'app.components.DepotForm.address',
    defaultMessage: 'Address',
  },
  zip: {
    id: 'app.components.DepotForm.zip',
    defaultMessage: 'Zip',
  },
  city: {
    id: 'app.components.DepotForm.city',
    defaultMessage: 'City',
  },
});
